import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-10 lg:gap-16">
          <Reveal className="self-start">
            <span className="text-xs md:text-sm tracking-[0.2em] text-primary-600">FAQ · 警示问答</span>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              关于口述与求助的常见问题
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              整理了几位读者最常提出的疑问，点击问题即可展开查看回答。
            </p>
          </Reveal>

          <Reveal delay={80}>
            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q} className={index !== faqs.length - 1 ? 'border-b border-background-200' : ''}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-900 leading-6">{item.q}</span>
                      <span
                        className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 md:px-6 pb-5 -mt-1">
                        <p className="text-sm leading-7 text-foreground-600 max-w-3xl">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}